import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { JobDescriptionComponent } from '../pages/management/job-description/job-description.component';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CompanySettingsService {

  private baseurl = "";
  private baseurlUtility = "";
  private apiroute = "";

  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;
    this.apiroute = '/FlexIntegration';
  }

  // GetClientSettings(name){
  //   console.log({method: 'Get_ClientSettingsByName', name: name});
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ClientSettingsByName', name: name})
  // }

  // GetCompanyTypes(){
  //   return this.http.post<any>(this.baseurl + '/public/GetOrganizationType', {})
  // }

  // GetCubePlans(){
  //   return this.http.post<any>(this.baseurl + '/public/GetCubePlans', {})
  // }

  // UpdateCreditCardInfo(obj: any){
  //   return this.http.post<any>(this.baseurl + this.apiroute, obj )
  // }

  // GetCreditCardInfo(myid: number){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByID', id: myid } )
  // }

  // GetCreditCardList(){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByCustomerID' } )
  // }

  UpdateCreditCardInfoTemp(obj: any){
    return this.http.post<any>(this.baseurl + '/public/UpdateCreditCardInfoTemp', obj)
  }  

  GetStripeCustomerList(){
    return this.http.post<any>(this.baseurl + '/public/getStripeCustomer', {})
  }

  updateCreditCardInfoStripeTemp(obj: any){
    return this.http.post<any>(this.baseurl + '/public/updateCreditCardInfoStripeTemp', obj)
  }  

  sendPaymentNotification(lparameterxml: string){
    return this.http.post<any>(this.baseurl + '/Notifications/NotificationGenericTemplate', { service: 
      'GetPaymentReminderLetterEmail', parameterxml: lparameterxml } )
  }  

  GetStripeCustomerId(){
    return this.http.post<any>(this.baseurl + '/public/getStripeCustomerId', {})
  }

  GetAllClientsWithStripeCustomerID(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'GetAllClientsWithStripeCustomerID' } )
  }

  getPaymentMethodById(obj: any){
    return this.http.post<any>(this.baseurl + '/public/getPaymentMethodById', obj )
  }

  // UpdateCreditCardInfoStripe(obj: any){
  //   return this.http.post<any>(this.baseurl + '/public/UpdateCreditCardInfoStripe', obj)
  // }

  getCustomerBilling(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CustomerBilliable' } )
  }

  // SaveNewExternalUser(newuser: any){
  //   return this.http.post<any>(this.baseurl + '/public/SaveNewExternalUser', newuser)
  // }

  // UpdateClientSettings(name, description, value){
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettings', name: name, description: description, value: value})
  // }

  // UpdateEstimateDefault(name, value){
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'UpdateEstimateDefaulvaluesCE',  name: name, value: value})
  // }

  // UpdateClientSettingsDescription(name, description){
  //   console.log({method: 'Update_ClientSettingsDescription', name: name, description: description})
  //   return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettingsDescription', name: name, description: description})
  // }

  // GetImgLogoPath(){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_ImgCompanyLogoPath' })
  // }

  // SaveDocument(filestring){
  //   return this.http.post(this.baseurl + '/DownloadFile/Upload', { filestring: filestring, doctype: 'logo', id: 1 })
  // }

  // GetDocument(filepath): Observable<any> {
  //   return this.http.post(this.baseurl + '/DownloadFile/Download', { filename: filepath });
  // }

  // GetUtility(method) {
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: method })
  // }

  // UpdateUtility(obj){
  //   console.log('Update ', obj);
  //   return this.http.post<any>(this.baseurl + this.apiroute, obj)
  // }

  GetClientSettings(name){
    // console.log('Voy en settings');
    // console.log({method: 'Get_ClientSettingsByName', name: name});
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ClientSettingsByName', name: name})
  }

  GetClientSettingsAll(){
    console.log({method: 'Get_ClientSettingsByName'});
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ClientSettings '})
  }

  GetConfigClientSettings(){
    // console.log({method: 'Get_ConfigClientSettings '});
    // console.log('Loading Get_ConfigClientSettings  XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX')
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ConfigClientSettings'})
  }

  GetCompanyTypes(){
    return this.http.post<any>(this.baseurlUtility + '/public/GetOrganizationType', {})
  }

  GetCubePlans(){
    return this.http.post<any>(this.baseurl + '/public/GetCubePlans', {})
  }

  UpdateCreditCardInfo(obj: any){
    return this.http.post<any>(this.baseurl + this.apiroute, obj )
  }

  GetCreditCardInfo(myid: number){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByID', id: myid } )
  }

  GetCreditCardList(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoByCustomerID' } )
  }

  GetCreditCardListAll(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CreditCardInfoAll' } )
  }

  RemoveCreditCardList(id: string){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Remove_CreditCardInfoByCustomerID', id: id } )
  }

  UpdateCreditCardInfoStripe(obj: any){
    return this.http.post<any>(this.baseurlUtility + '/public/UpdateCreditCardInfoStripe', obj)
  }

  SaveNewExternalUser(newuser: any){
    return this.http.post<any>(this.baseurl + '/public/SaveNewExternalUser', newuser)
  }

  Insert_TempUser(newuser: any){
    return this.http.post<any>(this.baseurlUtility + '/public/Insert_TempUser', newuser)
  }

  SendNotificationClientTempUser(email: any){
    return this.http.post<any>(this.baseurlUtility + '/Notifications/SendNotificationClientTempUser', email)
  }

  UpdateClientSettings(name, description, value){
    console.log({method: 'Update_ClientSettings', name: name, description: description, value: value});
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettings', name: name, description: description, value: value})
  }

  UpdateEstimateDefault(name, value){
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'UpdateEstimateDefaulvaluesCE',  name: name, value: value})
  }

  UpdateClientSettingsDescription(name, description){
    console.log({method: 'Update_ClientSettingsDescription', name: name, description: description})
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Update_ClientSettingsDescription', name: name, description: description})
  }

  GetImgLogoPath(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_ImgCompanyLogoPath' })
  }

  Get_CustomerBillingHistory(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CustomerBillingHistory' })
  }

  createPayment(obj: any){
    return this.http.post<any>(this.baseurlUtility + '/public/createCharge', obj )
  }

  updateCreditCardFromStripe(obj: any){
    return this.http.post<any>(this.baseurl + '/public/updateCreditCardFromStripe', obj )
  }

  SaveDocument(filestring){
    return this.http.post(this.baseurl + '/DownloadFile/Upload', { filestring: filestring, doctype: 'logo', id: 1 })
  }

  Get_CustomerBillingHistoryAll(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_AllCustomerBillingHistory' })
  }    

  Get_CustomerBilliable(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_CustomerBilliable' })
  }    

  // updateCreditCardFromStripe(){
  //   return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_AllCustomerBillingHistory' })
  // }    

  ModifyReqPaid(){
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'InsertUpdate_ProjectRequisitionAccounting' })
  }    

  GetDocument(filepath): Observable<any> {

    return this.http.post(this.baseurl + '/DownloadFile/Download', { filename: filepath });
  }

  GetUtility(method, parametro = null) {
    if(parametro == null) {
      return this.http.post<any>(this.baseurl + this.apiroute, { method: method })
    } else {
      return this.http.post<any>(this.baseurl + this.apiroute, { method: method, [parametro.propiedad]: parametro.valor })
    }
  }

  GetClientMasterDBCode(){
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'GetClientMasterDBCode'})
  }

  UpdateClientMasterDBCode(){
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'UpdateClientMasterDBCode' })
  }  

  UpdateUtility(obj){
    console.log('Update ', obj);
    return this.http.post<any>(this.baseurl + this.apiroute, obj)
  }
}
